import React from 'react';

import styles from '../pay.module.less';

export default class CountDown extends React.Component {
    timer = null

    time = 1800

    constructor(props) {
      super(props);
      this.state = {
        timeText: '30: 00', // 显示在页面上
      };
    }

    componentDidMount() {
      this.formatTime();
    }

    componentWillUnmount() {
      // 组件结束前的生命周期钩子
      clearInterval(this.timer);
      this.timer = null;
    }

    formatTime() {
      this.timer = setInterval(() => {
        if (this.time === 0) {
          // 现在不知道什么逻辑
          window.history.go(-1);
        } else {
          this.time -= 1;
          const hh = Math.floor(this.time / 60);
          const mm = this.time % 60 < 10 ? `0${this.time % 60}` : this.time % 60;
          this.setState({
            timeText: `${hh} : ${mm}`,
          });
        }
      }, 1000);
    }

    render() {
      const { timeText } = this.state;
      return (
        <div className={styles.count_down}>
          支付剩余时间&nbsp;
          { timeText }
        </div>
      );
    }
}
